/**
 * 全局超时配置
 *
 * 统一管理所有 AI 交互的超时时间
 */

/**
 * 首字超时（First Response Time）
 * - 从发送请求到收到第一个响应的最大等待时间
 * - 适用于：聊天消息、通话接听决策、AI 主动发起通话等
 */
export const AI_FIRST_RESPONSE_TIMEOUT_MS = 90_000 // 90 秒

/**
 * 流式空闲超时（Stream Idle Timeout）
 * - 收到第一个响应后，如果超过此时间没有新内容就超时
 * - 适用于：流式聊天内容生成
 */
export const AI_STREAM_IDLE_TIMEOUT_MS = 90_000 // 90 秒
